module.exports = __webpack_public_path__ + "img/introducePageFour_show_three.4a8f5242.jpg";